
/**
 * Javascript file for the AI readiness check welcome page.
 * @author Yannik Sprengart, Andrea Villeda.
 */

export default {
    name: "kircLanding",
  };


// WEBPACK FOOTER //
// ./src/components/company/kirc/landing/kirclanding.js